import React from 'react'
import Card from '../../commons/Card'
import { numberAddCommas } from 'servos/formValidations'
import { connect } from 'react-redux';
import GreyBig from './GreyBig'
import { getRefinanceReason, getLoanApplicationPurpose, getLoanApplicationTarget } from '../../../reducers'

class Documentation extends React.Component {
  loanObjectiveText = () => {
    const { purpose, refinanceReason, target } = this.props

    if (purpose === 'refinance') {
      return I18n.t(`loan_application_user.review.refinance_reason.${refinanceReason}`)
    } else {
      return I18n.t(`loan_application_user.review.home_purchase.${target}`)
    }
  }

  render() {
    const { review } = this.props

    return (
        <Card title='Home details' >
          <div className='card-body'>
            <GreyBig size='4' grey='Loan objective' big={this.loanObjectiveText()}/>
            <GreyBig size='4' grey='Type of loan' big={review.documentation.purpose}/>
            <GreyBig size='4' grey='Property' big={review.documentation.target}/>
            <div className='mb-4'>
              <div className='grey'>
                Address
              </div>
              <div className='big'>
                {review.documentation.address}
              </div>
            </div>
            <GreyBig size='4' grey='Value of home' big={'$'+numberAddCommas(review.documentation.spendAmount)}/>
            <GreyBig size='4' grey='Borrowing amount' big={'$'+numberAddCommas(review.documentation.loanAmount)}/>
            { review.documentation.purpose === 'Purchasing' && review.documentation.loanTarget === 'investment' &&
              <GreyBig size='4' grey='Rent amount' big={review.rentAmountLabel}/>
            }
          </div>
        </Card>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  review: state.review,
  refinanceReason: getRefinanceReason(state),
  purpose: getLoanApplicationPurpose(state),
  target: getLoanApplicationTarget(state),
})

export default connect(mapStateToProps, {
})(Documentation)
